var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color_select",class:{'dark_selected': _vm.darkStyle, 'light_selected': _vm.lightStyle},style:(_vm.style),on:{"click":_vm.action_Select}},[_c('v-icon',{staticClass:"check_icon"},[_vm._v("mdi-check-bold")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }